<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title mb-4">{{title | translate}}</div>
        <div class="col-12 text-center modal-subtitle mb-4">{{ action | translate }} {{ (selection._selected.length > 1
            ? 'ACTIONS.SELECTED_REQUEST_PLURAL': 'ACTIONS.SELECTED_REQUEST_SINGLE') | translate: { NUM_ACTIONS:
            selection._selected.length} }}?</div>
    </div>
    <div class="row d-flex justify-content-center">
        <form class="col-12">
            <label class="form-label" for="approveMessage">
                {{'ACTIONS.ADD_COMMENT' | translate}}
            </label>
            <textarea id="approveMessage" [(ngModel)]="approveMessage" name="message" class="col-12 form-content bg-transparent border"
                rows="5"></textarea>
        </form>
    </div>
    <div class="row">
        <div class="col-6 mt-4 d-flex justify-content-center">
            <button mat-flat-button class="btn-action white cancel-btn" (click)="closeModal()">{{'CANCEL' |
                translate}}</button>
        </div>
        <div class="col-6 mt-4 d-flex justify-content-center">
            <button mat-flat-button class="btn-action success approve-btn" (click)="confirmApproval()">{{title |
                translate}}</button>
        </div>
    </div>
</div>